module.exports = __webpack_public_path__ + "static/media/nodal.d3f3d5b0.svg";